import { FC } from 'react';
import ModalCore, { ModalCoreProps } from '../Modal/ModalCore';
import FileDropZone, { FileDropZoneProps } from './FileDropZone';

const FileDropZoneModal: FC<ModalCoreProps & FileDropZoneProps> = (props) => {
  const {
    isLoading = false,
    hasError = false,
    className,
    dropzoneOptions,
    ...rest
  } = props;

  return (
    <ModalCore
      className={'m-auto' + (className ? ' ' + className : '')}
      disableBackdropClick={false}
      {...rest}
    >
      <FileDropZone
        className="border-0"
        isLoading={isLoading}
        hasError={hasError}
        dropzoneOptions={dropzoneOptions}
      />
    </ModalCore>
  );
};

export default FileDropZoneModal;
